// src/App.js

import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { initGA, logPageView } from './analytics';
import Layout from './components/Layout';
import Register from './components/Register';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import RequireAuth from './components/RequireAuth';
import ListView from './components/ListView';
import ListDetail from './components/ListDetail';
import EventView from './components/EventView';
import EventDetails from './components/EventDetails';
import Profile from './components/Profile';
import VerifyEmail from './components/VerifyEmail';
import HomePage from './components/HomePage';
import LearnMorePage from './components/LearnMorePage';
import PublicLayout from './components/PublicLayout';
import Purchases from './components/Purchases';
import BlogIndex from './components/BlogIndex';
import BestFreeGiftListApp from './components/blog/BestFreeGiftListApp';
import TrackHolidayGiftSpending from './components/blog/TrackHolidayGiftSpending';
import SharedListsForCouples from './components/blog/SharedListsForCouples';


function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <Router>
      <RouteChangeTracker />
      <Routes>
        {/* Public Routes */}
        <Route element={<PublicLayout />}>
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/learn-more" element={<LearnMorePage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/best-free-gift-list-app-for-families" element={<BestFreeGiftListApp />} />
          <Route path="/blog/track-holiday-gift-spending" element={<TrackHolidayGiftSpending />} />
          <Route path="/blog/shared-lists-for-couples" element={<SharedListsForCouples />} />
        </Route>

        {/* Private Routes */}
        {/* Protected Routes */}
        <Route element={<RequireAuth><Layout /></RequireAuth>}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/lists" element={<ListView />} />
          <Route path="/lists/:id" element={<ListDetail />} />
          <Route path="/events" element={<EventView />} />
          <Route path="/events/:id" element={<EventDetails />} />
          <Route path="/purchases" element={<Purchases />} />
          <Route path="/profile" element={<Profile />} />
        </Route>

      </Routes>
    </Router>
  );
}

function RouteChangeTracker() {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

export default App;
